module.exports = __webpack_public_path__ + "static/media/work.bc03ae60.svg";